import BigPicture from 'bigpicture'
import '../stylesheets/single-home.scss'
import { isHomeFavorite, toggleHomeFavorite } from './utils/favorites'

document.addEventListener('DOMContentLoaded', function () {
	if (!document.body.classList.contains('single-home')) {
		return
	}

	setupHeroSlider()
	setupGalleryLightbox()
	setupFavoriteButton()
})

function setupFavoriteButton() {
	var favoriteButton = document.querySelector('.single-home-favorite-btn')
	var homeId = favoriteButton ? favoriteButton.getAttribute('data-home-id') : ''

	if (!favoriteButton || !homeId) {
		return
	}

	function renderFavoriteState(isFavorite) {
		var icon = favoriteButton.querySelector('.single-home-favorite-icon')
		var label = favoriteButton.querySelector('.single-home-favorite-label')

		favoriteButton.classList.toggle('is-favorite', isFavorite)
		favoriteButton.setAttribute('aria-pressed', isFavorite ? 'true' : 'false')
		favoriteButton.setAttribute(
			'aria-label',
			isFavorite ? 'Remove this home from favorites' : 'Save this home to favorites'
		)

		if (icon) {
			icon.textContent = isFavorite ? '♥' : '♡'
		}

		if (label) {
			label.textContent = isFavorite ? 'Saved to Favorites' : 'Save to Favorites'
		}
	}

	renderFavoriteState(isHomeFavorite(homeId))

	favoriteButton.addEventListener('click', function () {
		var result = toggleHomeFavorite(homeId)
		renderFavoriteState(result.isFavorite)
	})
}

function setupHeroSlider() {
	var hero = document.querySelector('.single-home-hero')
	var slides
	var dots
	var prevButton
	var nextButton
	var activeIndex = 0
	var autoplayDelay = 6000
	var autoplayId = null
	var touchStartX = 0
	var touchStartY = 0
	var swipeThreshold = 45

	if (!hero) {
		return
	}

	slides = Array.prototype.slice.call(hero.querySelectorAll('.single-home-hero-slide'))
	dots = Array.prototype.slice.call(hero.querySelectorAll('.single-home-hero-dot'))
	prevButton = hero.querySelector('.single-home-hero-arrow.prev')
	nextButton = hero.querySelector('.single-home-hero-arrow.next')

	if (slides.length <= 1) {
		return
	}

	function setActiveSlide(nextIndex) {
		activeIndex = (nextIndex + slides.length) % slides.length

		slides.forEach(function (slide, index) {
			slide.classList.toggle('is-active', index === activeIndex)
		})

		dots.forEach(function (dot, index) {
			dot.classList.toggle('is-active', index === activeIndex)
		})
	}

	function restartAutoplay() {
		window.clearInterval(autoplayId)
		autoplayId = window.setInterval(function () {
			setActiveSlide(activeIndex + 1)
		}, autoplayDelay)
	}

	if (prevButton) {
		prevButton.addEventListener('click', function () {
			setActiveSlide(activeIndex - 1)
			restartAutoplay()
		})
	}

	if (nextButton) {
		nextButton.addEventListener('click', function () {
			setActiveSlide(activeIndex + 1)
			restartAutoplay()
		})
	}

	dots.forEach(function (dot, index) {
		dot.addEventListener('click', function () {
			setActiveSlide(index)
			restartAutoplay()
		})
	})

	hero.addEventListener(
		'touchstart',
		function (event) {
			if (!event.touches || event.touches.length !== 1) {
				return
			}

			touchStartX = event.touches[0].clientX
			touchStartY = event.touches[0].clientY
		},
		{ passive: true }
	)

	hero.addEventListener(
		'touchend',
		function (event) {
			var touch
			var deltaX
			var deltaY

			if (!event.changedTouches || event.changedTouches.length !== 1) {
				return
			}

			touch = event.changedTouches[0]
			deltaX = touch.clientX - touchStartX
			deltaY = touch.clientY - touchStartY

			// Only respond to intentional horizontal swipes.
			if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) <= Math.abs(deltaY)) {
				return
			}

			if (deltaX < 0) {
				setActiveSlide(activeIndex + 1)
			} else {
				setActiveSlide(activeIndex - 1)
			}

			restartAutoplay()
		},
		{ passive: true }
	)

	hero.addEventListener('mouseenter', function () {
		window.clearInterval(autoplayId)
	})

	hero.addEventListener('mouseleave', restartAutoplay)

	restartAutoplay()
}

function setupGalleryLightbox() {
	var galleryLinks = Array.prototype.slice.call(document.querySelectorAll('.single-home-gallery-link'))

	if (!galleryLinks.length) {
		return
	}

	document.addEventListener('click', function (event) {
		var anchor = event.target.closest('.single-home-gallery-link')
		var items
		var startIndex

		if (!anchor) {
			return
		}

		event.preventDefault()
		items = galleryLinks.map(function (link) {
			return { src: link.href }
		})
		startIndex = galleryLinks.indexOf(anchor)

		if (startIndex === -1) {
			return
		}

		BigPicture({
			el: anchor,
			gallery: items,
			position: startIndex,
			noLoader: true,
		})
	})
}